import { defaultLayerUrl } from "../utils/constant";
import { APPID } from "../utils/keys";
import { getTemplateInfo } from "./CourseTemplateService";
import { getTeacherInfoBySurvey, queryQustionsInfo } from "./api";
import { retryFunction } from "./teacher";

export type RouterMatch = {
    activityId?: string | number;
    x_field?: string;
};
export type SearchMatch = {
    x_field_1?: string;
    sourceType?: string;
    activityId?: number;
    [keyName: string]: any;
};
/**
 * 格式化用户答案对象为表单可用数据
 * @param answerList 用户答案列表
 * @returns [答案对象， 是否已答题]
 */
export const formatAnswerObj = (answerList): [Object, boolean] => {
    let obj = {};
    let hadAnswer = false;
    answerList.forEach(item => {
        let answer;
        try {
            answer = JSON.parse(item.answer);
        } catch (error) {
            answer = item.answer;
        }
        if (item.answerFlag) hadAnswer = true;
        // 若未填则显示 ‘暂未答案’   --> 若首题未非必填且未答题显示将有异常但场景很少
        obj[item.question.name] = item.answerFlag || hadAnswer ? answer : undefined;
    });

    return [obj, hadAnswer];
};

/**
 * 获取问题验证roles
 * @param item 问题对象
 */
export const getVerifyRoles = item => {
    let roles: any[] = [
        {
            required: item.requiredFlag,
            message: '该选项为必填',
        },
    ];
    if (item.bizTypeName === '手机号码') {
        roles.push({
            pattern: new RegExp(/^(1[3-9][0-9])[0-9]{8}$/),
            message: '请输入正确的手机号',
        });
    }
    if (item.bizTypeName === '邮箱') {
        roles.push({
            pattern: new RegExp(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/),
            message: '请输入正确的邮箱',
        });
    }

    if (item.bizTypeName === '微信号码') {
        roles.push({
            pattern: new RegExp(/^[a-zA-Z]([-_a-zA-Z0-9]{5,20})$/),
            message: '请输入正确的微信号码',
        });
    }

    if(item.bizTypeName === '国际号') {
        roles.push({
            pattern: new RegExp(/^(86)1[3-9]\d{9}$|^(61)\d{9,10}$|^(44)\d{10,11}$|^(1)\d{10}$|^(?!(86|61|44|1))\d{1,3}[1-9]\d{1,14}$/),
            message: '请输入正确的手机号码',
        })
    }

    return roles;
};


/**
 * 获取表单信息
 * @param params 路由上的信息
 * @param isNeedTeacher 是否需要匹配助教信息
 */
export const getSurveyInfo = (params: RouterMatch, search?: SearchMatch,isNeedTeacher = false): Promise<any> =>
    new Promise(async (resolve, reject) => {
        let { status, result } = await queryQustionsInfo(params);
        if (!status && result) {

            let activity = result;

            let {
                survey,
                mktActivityShowAndShareConfigs,
                guideFlow,
                id,
                projectId,
                activityLotteryBO
            } = activity || {};

            // 获取模板信息-- 如果有模板配置 优先显示模板配置内容
            try {
                const {templateSource, templateConfigId} = activity?.channelDeliveryVersion || {};
                if(templateSource !== 1) {
                    const templateInfo  =await getTemplateInfo(templateConfigId);
                    Object.assign(activity,templateInfo,{})
                }
              
            } catch (error) {
                console.log(error);
            }
            let layerUrl = defaultLayerUrl;
            mktActivityShowAndShareConfigs = !!mktActivityShowAndShareConfigs?.length ? mktActivityShowAndShareConfigs[0] : {}
            if (mktActivityShowAndShareConfigs.layerUrl && mktActivityShowAndShareConfigs.layerType == 'CUSTOM') {
                layerUrl = mktActivityShowAndShareConfigs.layerUrl;
            }
            // 获取抽奖承接页数据 拼接
            if(activityLotteryBO) {
                const lotteryResult = lotterySuccessCfg(activityLotteryBO,search);
                activity = {...activity,...lotteryResult}
                guideFlow = activity?.guideFlow;
            }
            // 匹配助教
            let teacherInfo;
            if(isNeedTeacher) {
                if (!guideFlow) guideFlow = 'RECOMMEND_WECHAT';

                if (guideFlow == 'AUTO_ALLOCATION') {
                    let {x_field_1} = search || {};
                    let params = {
                        appID: APPID,
                        fieldFlag: x_field_1,
                        surveyName: survey?.name || '',
                    };
                    let scrmTeacherInfo: any = await retryFunction(retry =>
                        getTeacherInfoBySurvey({
                            ...params,
                            retries: retry,
                        })
                    );
                    if (!!scrmTeacherInfo) teacherInfo = scrmTeacherInfo;

                    // 若助教信息无qrcode，改为公众号承接
                    if (!teacherInfo?.weChatQrCode) {
                        guideFlow = 'RECOMMEND_WECHAT';
                    }
                }

                activity.guideFlow = guideFlow;
            }

            resolve({
                activity,
                survey,
                guideFlow,
                mktActivityShowAndShareConfigs,
                layerUrl,
                teacherInfo,
                activityLotteryBO

            });
        } else {
            reject(null);
        }
    });


/**抽奖承接页数据处理 */
export const lotterySuccessCfg = (activityLotteryBO,search) => {
    const {configCode} = search;

    const {contifs} = activityLotteryBO;
    const findLottery = contifs.find(v=>v.configCode == configCode) || {};
    const {activityLotteryProcessDTO} = findLottery;

    if(activityLotteryProcessDTO) {
        // const {
        //     guideFlow,
        //     redirectType,
        //     redirectUrl,
        //     redirectPath,
        //     redirectImage,
        //     guideDescription,
        //     headStatus,
        //     appletState,
        //     appletId,
        //     addAssistantText,
        //     isShowNickName,
        //     guideShowType, // 展示方式 0-直接展示助教信息 1-跳转按钮
        //     guideButtonDoc,
        //     courseInfoRedirect, //课程详情页已购买按钮跳转设置
        //     wecomTemplateId, //
        //     isUserQrCode,
        //     guideWordType, //引导文案类型:0默认模板,1模板2
        //     throwId,
        //     mktActivityProcessBannerDTO,
        //     isShowSpareStaff, //是否展示兜底账户入口
        //     grouponingLandPageDTO,   //拼团承接页扩展配置
        //     customBasemapUrl
        // } = activityLotteryProcessDTO;
        // 处理 承接页类型为空的情况
        if(!activityLotteryProcessDTO.guideFlow) return null;
        delete activityLotteryProcessDTO.ext;
        delete activityLotteryProcessDTO.id;
        delete activityLotteryProcessDTO.mktActivityProductExtDTO;
        return activityLotteryProcessDTO;
        // return {
        //     guideFlow,
        //     redirectType,
        //     redirectUrl,
        //     redirectPath,
        //     redirectImage,
        //     guideDescription,
        //     headStatus,
        //     appletState,
        //     appletId,
        //     addAssistantText,
        //     isShowNickName,
        //     guideShowType, // 展示方式 0-直接展示助教信息 1-跳转按钮
        //     guideButtonDoc,
        //     courseInfoRedirect, //课程详情页已购买按钮跳转设置
        //     wecomTemplateId, //
        //     isUserQrCode,
        //     guideWordType, //引导文案类型:0默认模板,1模板2
        //     throwId,
        //     mktActivityProcessBannerDTO,
        //     isShowSpareStaff, //是否展示兜底账户入口
        //     grouponingLandPageDTO,   //拼团承接页扩展配置
        //     customBasemapUrl
        // }
    } else {
        return null;
    }
}